import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddressSelector from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/AddressSelector/useAddressSelector'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'
import { SelectWrapper } from '@/shared/theme/styled-components'
import useClientTabMissingFields from '@/containers/SubscriptionFormPageNew/SubscriptionForm/ClientTabStatus/useClientTabMissingFields'

interface AddressSelectorFieldContentProps {
  module: string
  validations?: object
  saleName?: string
}

const AddressSelectorFieldContent = ({ module, validations, saleName }: AddressSelectorFieldContentProps) => {
  const isMissing = useClientTabMissingFields()
  const {
    t,
    label,
    addressesList,
    addressSelectorHandler,
    selectedValue,
    selectedLabel,
    CopyOverlay,
    addressError,
    isEditable,
    getOptionLabel,
  } = useAddressSelector(module, validations, saleName)

  if (!addressesList?.length) {
    return module === 'client' ? null : <p>{t('common:no_addresses_available')}</p>
  }

  return (
    <SDFormControl plainLabel error={addressError}>
      <SelectWrapper>
        {/* @ts-expect-error SDSelect is a JS component */}
        <SDSelect
          label={label}
          disabled={!isEditable}
          optionsList={addressesList}
          onChangeHandler={(params: { option?: { id?: string } }) => addressSelectorHandler(params.option?.id)}
          selectedValue={selectedValue}
          placeholder={t('common:choose')}
          getOptionLabel={getOptionLabel}
          missing={isMissing('addressChoice')}
        />
        <CopyOverlay>
          <CopyEndEnhancer value={selectedLabel} />
        </CopyOverlay>
      </SelectWrapper>
    </SDFormControl>
  )
}

export default AddressSelectorFieldContent
